import { recommendedOutreachMembersDataset } from '@/lib/member-views/datasets/recommendedOutreachMembers.dataset';
import type { RecommendedOutreachMemberRow } from '@/lib/members/members.types';
import { MemberIdentityCell } from '../cells/MemberIdentityCell';
import { PhoneCell } from '../cells/PhoneCell';
import { PriorityTagsCell } from '../cells/PriorityTagsCell';
import { MemberViewShell, type MemberViewShellProps } from '../MemberViewShell';

const cellOverrides: MemberViewShellProps<RecommendedOutreachMemberRow>['cellOverrides'] = {
  patient: (row) => <MemberIdentityCell firstName={row.firstName} lastName={row.lastName} mdvipId={row.mdvipId} />,
  phone: (row) => <PhoneCell mobile={row.mobilePhone} home={row.phone} />,
  priorityTags: (row) => <PriorityTagsCell tags={row.priorityTags} />,
};

/**
 * Recommended Outreach: the practice's Active members renewing soon who look likely to cancel.
 *
 * A function declaration for the same reason as `AllActiveMembersView`: the view registry and the
 * shell import each other, and a hoisted function survives that cycle where a `const` might not.
 */
export function RecommendedOutreachMembersView() {
  return <MemberViewShell dataset={recommendedOutreachMembersDataset} cellOverrides={cellOverrides} />;
}
